import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import s from 'components/bolt/controls/controls.sss';

export default class Controls extends Component {

	render({ imageRoot, toggleMute, toggleMotion, toggleLegals, currentPage, muted, motionPaused, inSidebar, sidePanelOpen, legalsOpen, copy, legalsPromptCopy }) {
		const isUpWorld = currentPage === 'upWorld';
		return (
			<div class={joinClasses(
				s.container,
				isUpWorld && s.isUpWorld,
				inSidebar && s.inSidebar,
				sidePanelOpen && s.panelOpen
			)}
			>
				<button
					class={s.soundControl}
					onClick={toggleMute}
				>
					<img class={s.airport} src={`${imageRoot}/controls/m2llym.webp`} />
					<img class={joinClasses(s.airport, !muted && s.hide)} src={`${imageRoot}/controls/m2llym-x.webp`} />
					<img class={s.upWorld} src={`${imageRoot}/controls/m2llym-up.webp`} />
					<img class={joinClasses(s.upWorld, !muted && s.hide)} src={`${imageRoot}/controls/m2llym-x-up.webp`} />
				</button>
				<button
					class={s.animControl}
					onClick={toggleMotion}
				>
					<img class={s.airport} src={`${imageRoot}/controls/r4lqk4.webp`} />
					<img class={joinClasses(s.airport, !motionPaused && s.hide)} src={`${imageRoot}/controls/r4lqk4-x.webp`} />
					<img class={s.upWorld} src={`${imageRoot}/controls/r4lqk4-up.webp`} />
					<img class={joinClasses(s.upWorld, !motionPaused && s.hide)} src={`${imageRoot}/controls/r4lqk4-x-up.webp`} />
				</button>
				<button
					class={joinClasses(s.legalsBtn, legalsOpen && s.legalsOpen)}
					onClick={toggleLegals}
					onMouseEnter={!legalsOpen && toggleLegals}
					onMouseLeave={legalsOpen && toggleLegals}
				>
					<img class={s.airport} src={legalsOpen ? `${imageRoot}/controls/vx3gaq.webp` : `${imageRoot}/controls/6l3rdx.webp`} />
					<img class={s.upWorld} src={`${imageRoot}/controls/6l3rdx-up.webp`} />
					<div class={s.legalsPrompt}><p>{legalsPromptCopy}</p></div>
				</button>
			</div>
		);
	}
}